import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import HttpStatus from '../../utility/status.enum';

const {
  fetchTasksBegin, fetchTasksSuccess, fetchTasksErr,
  fetchVerbiagesBegin, fetchVerbiagesSuccess, fetchVerbiagesErr,
  completeTaskBegin, completeTaskSuccess, completeTaskErr,
} = actions;

const fetchTaskGroupsAPI = '/admin/tasks';
const fetchTaskVerbiagesAPI = '/admin/tasks/verbiages';
const completeTaskAPI = '/admin/tasks/complete';
const completeTaskBulkAPI = '/admin/tasks/complete/bulk';

const fetchTaskGroups = (values) => {
  return async (dispatch) => {
    dispatch(fetchTasksBegin());
    try {
      const response = await DataService.get(`${fetchTaskGroupsAPI}?${new URLSearchParams(values).toString()}`);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(fetchTasksErr(response?.data?.message));
      } else {
        dispatch(fetchTasksSuccess());
      }
      return response?.data;
    } catch (err) {
      dispatch(fetchTasksErr(err));
    }
  };
};

const fetchTaskVerbiages = (values) => {
  return async (dispatch) => {
    dispatch(fetchVerbiagesBegin());
    try {
      const response = await DataService.get(`${fetchTaskVerbiagesAPI}?${new URLSearchParams(values).toString()}`);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(fetchVerbiagesErr(response?.data?.message));
      } else {
        dispatch(fetchVerbiagesSuccess());
      }
      return response?.data;
    } catch (err) {
      dispatch(fetchVerbiagesErr(err));
    }
  };
};

const completeTaskVerbiage = (values) => {
  return async (dispatch) => {
    dispatch(completeTaskBegin());
    try {
      const response = await DataService.post(completeTaskAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(completeTaskErr(response?.data?.message));
      } else {
        dispatch(completeTaskSuccess());
      }
      return response?.data;
    } catch (err) {
      dispatch(completeTaskErr(err));
    }
  };
};

const completeTaskVerbiageBulk = (values) => {
  return async (dispatch) => {
    dispatch(completeTaskBegin());
    try {
      const response = await DataService.post(completeTaskBulkAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(completeTaskErr(response?.data?.message));
      } else {
        dispatch(completeTaskSuccess());
      }
      return response?.data;
    } catch (err) {
      dispatch(completeTaskErr(err));
    }
  };
};

export { fetchTaskGroups, fetchTaskVerbiages, completeTaskVerbiage, completeTaskVerbiageBulk };
